import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/membershipLengthSagas";

const GroupByFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.membershipLengthByAgreement.filters.group_by);
  const selectedOption = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.group_by
  );

  return (
    <div className="select-box" style={{ width: "145px" }}>
      <p>Group By</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updateFilters({ group_by: data }))}
      />
    </div>
  );
};

export default GroupByFilter;
